import React from 'react';

const Tableau = ({
    Entete, Lignes, Pied, PasDeZebrures, PetitesLignes, className,
}) => (
    <div className="table-responsive">
        <table width="100%"
            className={`table ${PasDeZebrures ? '' : 'table-striped'} table-hover ${
                PetitesLignes ? 'table-sm' : ''
            } ${className}`}
        >
            <thead>{Entete}</thead>
            <tbody>
                {Lignes}
                {Pied}
            </tbody>
        </table>
    </div>
);

export default Tableau;



// WEBPACK FOOTER //
// ./src/components/Tableau.js